import image_1 from 'asset/case_1.png';
import image_2 from 'asset/case_2.png';
import image_3 from 'asset/case_3.png';

export const data_use_cases = {
  prefix: 'How it works',
  title: 'THE AI <span>BEHIND THE EXPERIENCE</span> ',
  items: [
    {
      id: 1,
      image: image_1,
      title: 'Smarter Searches <br/> and Instant Results ',
      content: [
        {
          id: 1,
          title: 'Conversational AI Search',
          description:
            'Customers can describe what they’re looking for in their own words, and the assistant, delivers tailored recommendations with built-in guardrails to ensure accuracy and relevance.',
        },
        {
          id: 2,
          title: 'AI-Driven Filtering',
          description:
            'Dynamic, real-time filters adapt to customer preferences, making product discovery smoother and more intuitive.',
        },
      ],
    },
    {
      id: 2,
      image: image_2,
      title: 'Try Before You Buy — Virtually',
      content: [
        {
          id: 1,
          title: 'Real-Time Visualization:',
          description:
            'With a quick snap from a phone or computer camera, shoppers can see how garments look on their own image instantly.',
        },
        {
          id: 2,
          title: 'Community Sharing:',
          description:
            'Customers can share their virtual try-on results with friends and family, making shopping more interactive and social.',
        },
        {
          id: 3,
          title: '3D Fit Simulation:',
          description:
            'A shopping assistant creates accurate 3D avatars based on body measurements, ensuring a realistic fit — even accounting for movement.',
        },
      ],
    },
    {
      id: 3,
      image: image_3,
      title: 'Utilizing NVIDIA AI <br/>for Precision and Performance ',
      content: [
        {
          id: 1,
          title: 'Conversational AI Engine:',
          description:
            'Powered by NVIDIA® Riva and NVIDIA NeMo™ Guardrails, the assistant delivers fast, natural interactions while maintaining security.',
        },
        {
          id: 2,
          title: 'Real-Time Image Processing:',
          description:
            'Advanced segmentation and body pose estimation (optimized with NVIDIA TAO Toolkit) ensure precise and seamless virtual try-ons.',
        },
        {
          id: 3,
          title: 'Enhanced Object Recognition:',
          description:
            'The NVIDIA NIM™ microservices for Llama-3.2-90B and Retail Object Detection NIM microservices refine product recommendations and improve accuracy.',
        },
        {
          id: 4,
          title: 'High-Resolution AI-Generated Visuals:',
          description:
            'Stable Diffusion XL NIM Mocroservice creates lifelike, high-quality try-on previews, bringing a new level of realism to online shopping.',
        },
      ],
    },
  ],
};
